module.exports = __webpack_public_path__ + "media/images/icons/filled/pause-circle-67b05ded706a817d52e90aedec46a6ca.svg";